import { IPlan } from "../../interfaces/api";
import { SORT } from "../../routes/all_plans";

const sortLabels = Object.values(SORT).map((sort) => sort.label);

const Sorter = ({
  plans,
  initialSortBy,
  setSortBy,
}: {
  plans: IPlan[];
  initialSortBy: string;
  setSortBy: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div
      className="grid-container grid-x"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "48px 62px 0px 27px",
      }}
    >
      <div className="cell small-12 medium-6" style={{ padding: "16px" }}>
        Showing {plans.length} plans
      </div>
      <div className="flex-container cell small-12 medium-6">
        <div
          style={{
            minWidth: "80px",
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "16px",
          }}
        >
          Sort by
        </div>
        <select
          defaultValue={initialSortBy}
          style={{
            padding: "0px 16px",
            cursor: "pointer",
          }}
          onChange={(e) => {
            setSortBy(e.target.value);
          }}
        >
          {sortLabels.map((label, index) => (
            <option key={index} value={label}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Sorter;
